import {Component, prop, watch} from 'vue-property-decorator';
import {Titles} from './titles/titles';
import {Column} from './column/column';
import {filtersService} from '../filters/filters'
import {Diet} from "../../models/diet";
import Vue from 'vue';

function reduceToGroup(carry, nut) {
    if (!carry[nut.group.title]) {
        carry[nut.group.title] = [];
    }
    carry[nut.group.title].push(nut);
    return carry;
}

@Component({
    template: require('./table.html'),
    components: {
        titles: Titles,
        column: Column,
    }
})
export class Table {
    @prop(Object)
    subspecies;

    @prop(Array)
    adjustments;

    @prop(Array)
    nutrients;

    @prop(Array)
    diets;

    @prop(String)
    specie;

    @prop(String)
    image;
    sticky = false;

    download = '';
    type = '';
    csrf = '';
    filter = [];
    form_filter = '';
    filter_adjustments = '';
    diets_count = '';

    get only_nutrients() {
        return this.nutrients.filter(nut => nut.type == 0)
            .reduce(reduceToGroup, {});
    }

    get ingredients() {
        return this.nutrients.filter(nut => nut.type == 1)
            .reduce(reduceToGroup, {});
    }

    add() {
        this.$emit('add');
    }

    remove(diet) {
        let index = this.diets.indexOf(diet);
        this.diets.splice(index, 1);
    }

    save() {
        this.$emit('save');
    }

    mounted() {
        let $el = $(this.$el);
        let $window = $(window);
        let scroll = () => {
              if ($window.scrollTop() - $el.offset().top > 0) {
                  let $scroll = $window.scrollTop() - $el.offset().top;
                  $('.top').css('transform', 'translate3d(0px,' + $scroll + 'px,0px)');
                  $('.add_diet').css('transform', 'translate3d(0px,' + $scroll + 'px,0px)');
            }
            else {
                $el.find('.top').css('transform', 'translate3d(0px,0px,0px)');
                $el.find('.add_diet').css('transform', 'translate3d(0px,0px,0px)');
            }
        };


        $window.on('scroll', scroll);
        scroll();

        this.csrf = $('meta[name="csrf-token"]').attr('content');
    }

    print(type) {

        let filters = filtersService;
        let fs = {};

        let types = {};
        let energy = {};
        let acids = {};
        let fes = {};
        let adjust = {};
        let spiecies = {};
        let selection = {};

        let vm = this;

        adjust = this.adjustments.map((adj) => {
            return [
                adj.title,
                ...this.diets.map(diet => adj.items.map(item => {
                    let v = diet.adjustment_values[item.id];

                    if (item.type == 1) {
                        v = (item.data ? item.data.selection : [])[v];
                        v = v ? v.name : v;
                    }

                    return v;
                }))
            ];
        });


        this.subspecies.siblings.map((spies) => {
            if (this.subspecies.title === spies.title) {
                spiecies[spies.title] = true
            } else {
                spiecies[spies.title] = false
            }
        });

        types[this.$t('builder.nutrient')] = filters.nutrient_type[0];
        types[this.$t('builder.ingredient')] = filters.nutrient_type[1];
        energy['Kcal'] = filters.energy_unit[0];
        energy['EW'] = filters.energy_unit[1];
        energy['MJ'] = filters.energy_unit[2];
        acids[this.$t('filters.absolute')] = filters.ratio[0];
        acids[this.$t('filters.ratio')] = filters.ratio[1];
        fes['CNS'] = filters.fes === 1;
        fes['CVB'] = filters.fes === 0;

        selection['%'] = filters.weight_unit === 1;
        selection['g/kg'] = filters.weight_unit === 0;

        fs[this.$t('filters.subspecies')] = spiecies;
        fs[this.$t('filters.nutrient')] = types;
        fs[this.$t('filters.fes')] = fes;
        fs[this.$t('filters.selection')] = selection;
        fs[this.$t('filters.energy')] = energy;
        fs[this.$t('filters.acids')] = acids;


        let groups = [];
        let rows = [];

        function group() {
            groups.push(rows);
            rows = [];
        }

        // Diet titles row. All but first col should be colspan 2
        rows.push(
            ['', ...this.diets.map(d => d.title)]
        );

        rows.push(...adjust);
        group();
        let sets = {};

        sets[this.$t("builder.nutrient")] = this.only_nutrients;
        sets[this.$t("builder.ingredient")] = this.ingredients;

        for (let name in sets) {
            let set = sets[name];

            if (Object.keys(set).length) {
                // Type row (nut/ingredient)


                rows.push(
                    [name].concat(...this.diets.map(() => ['min', 'max',]))
                );

                for (let i in set) {
                    // Group row
                    // add empty row anders lopen de lijnen fout
                    rows.push(['<b>' + `${i}` + '</b>'].concat(...this.diets.map(() => ['', '',])));

                    for (let n of set[i]) {

                        // Nutrient rows
                        rows.push(
                            // TODO add unit
                            [`${n.title} ` + '<span class="unit">' + `${n.unit}` + '</span>'].concat(...this.diets.map(d => [
                                d.getNutrientMin(n.id),
                                d.getNutrientMax(n.id),
                            ]))
                        );
                    }
                }

                group();
            }
        }
        vm.diets_count = vm.diets.length;
        this.filter_adjustments = JSON.stringify(this.adjustments);
        this.download = JSON.stringify(groups);
        this.type = type;
        this.form_filter = JSON.stringify(fs);
        Vue.nextTick(() => {
            let vm = this;
            $(this.$el).find('form').submit();
        });
    }
}
